import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a1c896ffc6897a806469098ebf2ba38b3b from "./generated-b4974efc-8e77-43f5-975a-73ce4b864ed9.json";

import a30eac22e8d9f4eb3f22545e1234ee975b from "./generated-576801d4-81d4-441a-bc4b-a9fb775fdf42.json";

import a7b68c1866cc55b7fcfb62667ab6577beb from "./generated-415f282f-8668-4580-9049-520ab775a1e7.json";

import adb4866aebbe333a99a82e30e526d0bc5b from "./generated-55ec417e-34a4-4f9c-86ac-ff31323e1625.json";

import a089477e8a71e1641cf29d2306ea1b5bdb from "./generated-78da85d7-2ff3-4b14-b333-d9a3a5796c74.json";

import af14ecd691453330116fd48f506de450fb from "./generated-f4270555-b94d-4b8b-aeb9-5120a2ef9d63.json";

import ad4a5035516fc13311ffc2bd23903a947b from "./generated-a4102590-c150-431d-89c6-24f673a63d0e.json";

import accc09580407d5bcee444616a6ddfad22b from "./generated-069fdad3-20f2-4fb3-bb8c-6fe236caadf9.json";

import a45cc48099780d5d39ae7826b03fb038bb from "./generated-029bc0a6-4dbc-4290-82cd-f58315875e61.json";

import aa4619702709de394c7cdf645ba50c5fcb from "./generated-3d95e9e8-9816-4c93-bb0e-df165628848c.json";

import a45c232d6a8c9cb928e8e4e8b41b4eadcb from "./generated-6d631d5a-474c-4218-a55d-0e57046c1885.json";

import ad58ac90a6332173c5d789cb500f191dcb from "./generated-b5bfcd1b-78c1-4ba4-a057-5aa6b5c5cb2f.json";

import a210883fe342629d3bdec0f5305bd859ab from "./generated-b5bd1730-d9e4-4a84-bac6-c96e56398dfa.json";

import a84e6bd7d17a47625d690e8975f807f7bb from "./generated-39a9d16b-8956-44f8-92df-eecd4bd1c52f.json";

import adc90dac2ee7587abea5ca7b212f22f87b from "./generated-fff4b3f0-b88d-40e9-ae66-0e7f833061f1.json";

import adc4733fd5f0255cce42445e37e06dd35b from "./generated-9c691b51-943d-441d-8666-2c8185066e22.json";

import ae17d3754092976d2a294e44b2a6061edb from "./generated-d9639301-3a50-4b87-9118-b4ad994a7726.json";

import a33a98831cd7f068b9a0ceea47eec95a1b from "./generated-4e3f1847-399e-4ee6-b95b-a5d9500d4524.json";

import aa69da0bb4cd048c5308081cf93b8fd5ab from "./generated-08189af3-6737-48e6-9c02-88a1cefda2cb.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a1c896ffc6897a806469098ebf2ba38b3b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a30eac22e8d9f4eb3f22545e1234ee975b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a7b68c1866cc55b7fcfb62667ab6577beb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(adb4866aebbe333a99a82e30e526d0bc5b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a089477e8a71e1641cf29d2306ea1b5bdb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(af14ecd691453330116fd48f506de450fb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ad4a5035516fc13311ffc2bd23903a947b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(accc09580407d5bcee444616a6ddfad22b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a45cc48099780d5d39ae7826b03fb038bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aa4619702709de394c7cdf645ba50c5fcb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a45c232d6a8c9cb928e8e4e8b41b4eadcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ad58ac90a6332173c5d789cb500f191dcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a210883fe342629d3bdec0f5305bd859ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a84e6bd7d17a47625d690e8975f807f7bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(adc90dac2ee7587abea5ca7b212f22f87b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(adc4733fd5f0255cce42445e37e06dd35b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ae17d3754092976d2a294e44b2a6061edb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a33a98831cd7f068b9a0ceea47eec95a1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aa69da0bb4cd048c5308081cf93b8fd5ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ae17d3754092976d2a294e44b2a6061edb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */